import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3185efc4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=3185efc4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=3185efc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185efc4",
  null
  
)

export default component.exports